import React, { useState, useEffect, useRef } from "react";
import Breadcrumb from "./Breadcrumb";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { Formik, FieldArray } from "formik";
import { ProductService } from "../../../services/product-service";
import { notify, notifyError, notifyWarning } from "../Toastmessage/Toastmessage";
import { ToastContainer } from "react-toastify";
import * as Yup from "yup";
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Select from "react-select";
import { ReportService } from "../../../services/reports-service";
import '../../../assets/css/style.css';

// Register custom fonts with Quill
let Font = Quill.import("attributors/style/font");
Font.whitelist = ['UNEmanee', 'Outfit'];
Quill.register(Font, true);

// const font = Quill.import('formats/font');
// font.whitelist = ['asap', 'podkova'];
// Quill.register(font, true);

const modules = {
  toolbar: [
      [{ 'font': Font.whitelist }],
      [{ 'size': [] }],
      ['bold', 'italic', 'underline', 'strike','blockquote'],
      [{ 'color': [] }, { 'background': [] }],
      [{ 'script': 'sub'}, { 'script': 'super' }],
      ['link', 'image', 'video'],
      [{ 'align': [] }],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      [{ 'direction': 'rtl' }],
      [{ 'indent': '-1'}, { 'indent': '+1' }],
      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
    ],
}

const formats = [
  'font',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'color',
  'background',
  'script',
  'link',
  'image',
  'video',
  'align',
  'list',
  'bullet',
  'direction',
  'indent',
  'header'
];

export const Addproductcontent = (props) => {
  var bodyFormData = new FormData();

  const formRef = useRef();

  const [products, setProducts] = useState([]);
  const [publishers, setPublishers] = useState([]);

  const [subjects, setSubjects] = useState([]);
  const [mediums, setMediums] = useState([]);

  const [submitloading, setSubmitLoading] = useState(true);

  const [showGroupProduct, setShowGroupProduct] = useState(false);

  const [selectedOption, setSelectedOption] = useState('');

  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);
  const [mainUploadedFile, setMainUploadedFile] = useState(null);

  const [productId, setProductId] = useState(0);
  const [stockCount, setStockCount] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [descripValue, setDescripValue] = useState("");
  
  const [categories, setCategories] = useState([]);

  const [seoTitle, setSeoTitle] = useState("");
  const [slug, setSlug] = useState("");

  const fileInputRef = useRef(null);

  const handleSlugChange = (e) => {
    const value = e.target.value;
    const formattedSlug = value.toLowerCase()
                              .replace(/ /g, '_')
                              .replace(/[^\w-]+/g, '');
    setSlug(formattedSlug);
};

const handleSeoTitleChange = (e) => {
  const value = e.target.value;
  const formattedSlug = value.toLowerCase()                   // Convert to lowercase
                              .replace(/[^a-z0-9\s-]/g, '')    // Remove special characters
                              .trim()                          // Remove leading/trailing spaces
                              .replace(/\s+/g, '_')            // Replace spaces with hyphens
                              .replace(/-+/g, '_');  
  setSlug(formattedSlug);
  setSeoTitle(value)
};

  const handleDropdownChange = (e) => {
    const selectedValue = e.target.value;
    setSelectedOption(selectedValue);

    // Show the text box when a specific option is selected (you can customize this condition)
    if (selectedValue === 'group') {
      setShowGroupProduct(true);
      setProductId(null);
      setStockCount(0);
    }  else if(selectedValue === 'single') {
      setShowGroupProduct(false);
      setProductId(null);
      setStockCount(0);

    }else{
      setShowGroupProduct(false);
      setProductId(null);
      setStockCount(0);

    }
  };
  
  const handleFileChange = (e) => {
    const filesArray = Array.from(e.target.files);
    const previews = filesArray.map((file) => URL.createObjectURL(file));
    setImagePreviews(previews);
    setSelectedFiles({'files': e.target.files});
  };

  const handleMainFileChange = (e) => {
    setMainUploadedFile(e.target.files[0]);
  };

  const productDetailGetId = async () => {
    if(productId > 0){
      const result = await ProductService.productDetailsID(productId);
      if(result.stock > 0){
        if(result.stock < 1){
          notifyError(result.name +' has only ' + result.stock + ' products in stock')
        }
        
        if(result.stock >= 1 ){
          const totalQuantity = 1;
          if(result.stock <= totalQuantity){
            notifyError(result.name +' has only ' + result.stock + ' products in stock')
          }
        }
      }else{
        notifyError(result.name + ' is out of stock')
      }
    }
    

  }

  const onSubmitForm = async (
    values,
    { resetForm, setErrors, setStatus, setSubmitting, setFieldValue }
  ) => {
    //todo extra validations
    setSubmitLoading(false);

    if(selectedFiles.files){
      for (const key of Object.keys(selectedFiles.files)) {
        bodyFormData.append('files', selectedFiles.files[key])
        }
    }
      
    bodyFormData.append("name", values.name);
    bodyFormData.append('main_image', mainUploadedFile)
    bodyFormData.append("description", descripValue);
    bodyFormData.append("weight", values.weight);
    bodyFormData.append("youtube_video", values.youtube_video);
    bodyFormData.append("publisher", values.publisher);
    bodyFormData.append("subject", values.subject);
    bodyFormData.append("medium", values.medium);
    bodyFormData.append("grade", values.grade);
    bodyFormData.append("level3cat", values.level3cat);
    bodyFormData.append("stock", values.stock);
    bodyFormData.append("low_stock", values.low_stock);
    bodyFormData.append("price", values.price);
    bodyFormData.append("product_group_type", selectedOption);
    bodyFormData.append("seo_title", seoTitle);
    bodyFormData.append("seo_description", values.seo_description);
    bodyFormData.append("seo_keyword", values.seo_keyword);
    bodyFormData.append("seo_image", values.seo_image);
    bodyFormData.append("img_alt", values.img_alt);
    bodyFormData.append("groupProducts", JSON.stringify(values.groupProducts));
    bodyFormData.append("type", values.type);
    bodyFormData.append("slug", slug);
    // bodyFormData.append("files", values.files);
    try {
      await ProductService.productCreate(bodyFormData);

      setSelectedFiles(null);
      setImagePreviews(null);
      setMainUploadedFile(null);
      setDescripValue(null);
      setSeoTitle('');
      setSlug('');
      setSubmitLoading(true);
      // Reset the file input field
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      notify("Product successfully added");
      // Reset the Formik form
    if (formRef.current) {
      formRef.current.resetForm();
    }
    } catch (err) {
      setSubmitLoading(true);

      if (err.response.data.message !== undefined) {
        notifyWarning(err.response.data.message);
      } else {
        notifyWarning("Something Wrong");
      }
    }
  };

  const productDetailsSearch = async () => {
    try {
      const filter = [{"product_group_type": "single"},{"status": "ACTIVE"}, {"stock": "instock"}]
      const result = await ProductService.allproductsNames();

      setProducts(result);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  const staticGetAll = async () => {
    try {
      const result = await ReportService.staticDetails();
      setPublishers(result.publishers);
      setSubjects(result.subjects);
      setMediums(result.mediums);
      setCategories(result.categoriesOrderByOrderId);
    } catch (err) {
      //toast
      console.error(err);
    }
  };

  useEffect(()=> {
    productDetailsSearch();
    staticGetAll();
  },[])

  useEffect(()=> {
    productDetailGetId();
  },[productId, stockCount])

  let ProductOptions = products.map((product) => ({
    value: product.id,
    label: product.name,
  }));

  return (
    <div className="ms-content-wrapper">
      <div className="row">
        <div>
          <ToastContainer />
        </div>
        <div className="col-md-12">
          <Breadcrumb />
        </div>

        <div className="col-xl-12 col-md-12">
          <div className="ms-panel ms-panel-fh">
            <div className="ms-panel-header">
              <h6>Add Product Form </h6>
            </div>
            <div className="ms-panel-body">
              <div className="row">
                <div className="col-sm-12">
                  <Formik
                    initialValues={{
                      name: "",
                      main_image: "",
                      description: "",
                      weight: 0,
                      youtube_video: "",
                      publisher: "",
                      subject: "",
                      medium: "",
                      grade: "",
                      level3cat: "",
                      stock: 0,
                      low_stock: 0,
                      price: "",
                      seo_title: "",
                      seo_description: "",
                      seo_image: "",
                      seo_keyword: "",
                      img_alt: "",
                      groupProducts: [],
                      files: "",
                      type: "",
                      product_group_type: ""
                    }}
                    validationSchema={Yup.object().shape({
                      name: Yup.string()
                        .required("Required")
                        .min(2, "name must have at least 2 characters")
                        .max(100, "name must have less than 50 characters"),
                      main_image: Yup.string(),
                      weight: Yup.string().required("Required"),
                      publisher: Yup.string().required("Required"),
                      subject: Yup.string().required("Required"),
                      medium: Yup.string().required("Required"),
                      grade: Yup.string().required("Required"),
                      stock: Yup.string().required("Required"),
                      price: Yup.string().required("Required"),
                      type: Yup.string().required("Please, select type"),
                      level3cat: Yup.string().required("Please, select category"),
                      product_group_type: Yup.string().required("Please, select product type"),
                      // files: Yup.string().required("Please, select an image"),
                      // groupProducts: Yup.array()
                      //   .required("Must have products") // these constraints are shown if and only if inner constraints are satisfied
                      //   .min(1, "Minimum of 1 products"),
                      
                    })}
                    onSubmit={onSubmitForm}
                    innerRef={formRef}
                    render={({
                      errors,
                      handleBlur,
                      handleChange,
                      touched,
                      values,
                      submitForm,
                      isValid,
                      setFieldValue,
                    }) => (
                      <div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">Name</label>
                            <div className="input-group">
                              <input
                                name="name"
                                type="text"
                                className="form-control"
                                id="nameid"
                                placeholder="Name"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.name}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.name && errors.name}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Weight
                            </label>
                            <div className="input-group">
                              <input
                                name="weight"
                                type="text"
                                className="form-control"
                                id="weightid"
                                placeholder="weight"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.weight}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.weight && errors.weight}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-12 mb-5">
                            <label htmlFor="validationCustom08">
                              Description
                            </label>
                            <div className="input-group">
                              <ReactQuill 
                                theme="snow" 
                                name="description" 
                                className="editor-input" 
                                value={descripValue} 
                                onChange={(e) => {
                                  setDescripValue(e)
                                }}
                                modules={modules}
                                formats={formats}
                              />
                              {/* <textarea
                                name="description"
                                className="form-control"
                                id="descriptionid"
                                placeholder="Description"
                                rows={4}
                                cols={40}
                                value={values.description}
                                onChange={handleChange}
                              /> */}
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.description && errors.description}
                            </div>
                          </div>
                        </div>
                        <div className="form-row mt-4">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Youtube Video(Embedded URL)
                            </label>
                            <div className="input-group">
                              <input
                                name="youtube_video"
                                type="text"
                                className="form-control"
                                id="youtube_videoid"
                                placeholder="youtube video"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.youtube_video}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.youtube_video && errors.youtube_video}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Publisher
                            </label>
                            <div className="input-group">
                              <select
                                name="publisher"
                                className="form-control"
                                id="publisherid"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.publisher}
                              >
                                <option value="">Select Publisher</option>
                                {publishers.map((publisher) => {
                                  return (
                                    <option key={publisher.id} value={publisher.id}>{publisher.name}</option>
                                  )
                                })}
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.publisher && errors.publisher}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Subject
                            </label>
                            <div className="input-group">
                              <select
                                name="subject"
                                className="form-control"
                                id="subjectid"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.subject}
                              >
                                <option value="">Select Subject</option>
                                {subjects.map((subject) => {
                                  return (
                                    <option key={subject.id} value={subject.id}>{subject.name}</option>
                                  )
                                })}
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.subject && errors.subject}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Medium
                            </label>
                            <div className="input-group">
                              <select
                                name="medium"
                                className="form-control"
                                id="medium"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.medium}
                              >
                                <option value="">Select Medium</option>
                                {mediums.map((medium) => {
                                  return (
                                    <option key={medium.id} value={medium.id}>{medium.name}</option>
                                  )
                                })}
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.medium && errors.medium}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Grade
                            </label>
                            <div className="input-group">
                              <select
                                name="grade"
                                className="form-control"
                                id="gradeid"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.grade}
                              >
                                <option value="">Select grade</option>
                                <option value="12">12</option>
                                <option value="13">13</option>
                                <option value="12/13">12 - 13</option>
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.grade && errors.grade}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom15">Type</label>
                            <div className="input-group">
                              <select
                                name="type"
                                className="form-control"
                                id="selecttype"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.type}
                              >
                                <option value="">Select Type</option>
                                <option value="Theory">Theory</option>
                                <option value="Revision">Revision</option>
                                <option value="Practical">Practical</option>
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.type && errors.type}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Category
                            </label>
                            <div className="input-group">
                              <select
                                name="level3cat"
                                className="form-control"
                                id="categoryid"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.level3cat}
                              >
                                <option value="">Select Category</option>
                                {categories.map((category) => {
                                  return (
                                    <option key={category.id} value={category.id}>{category.name}</option>
                                  )
                                })}
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.price && errors.price}
                            </div>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Price
                            </label>
                            <div className="input-group">
                              <input
                                name="price"
                                type="number"
                                className="form-control"
                                id="priceid"
                                placeholder=""
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.price}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.price && errors.price}
                            </div>
                          </div>
                        </div>
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <div>
                                  <label htmlFor="validationCustom08">
                                    Upload Main Image
                                  </label>
                                  <div>
                                  {mainUploadedFile != null && 
                                    <img
                                      alt=""
                                      style={ { width: "100px", height: "100px"}}
                                      src={
                                        mainUploadedFile != null
                                          ? URL.createObjectURL(mainUploadedFile)
                                          : ""
                                      }
                                    />
                                  }
                                  </div>
                                </div>
                                <div className="mb-3 mt-2">
                                  <input
                                    type="file"
                                    name="main_image"
                                    ref={fileInputRef}
                                    onBlur={handleBlur}
                                    onChange={(event) => {
                                      handleMainFileChange(event);
                                      setFieldValue("main_image", event.target.files[0]);
                                    }}
                                  />
                                  <div
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {touched.main_image && errors.main_image}
                                  </div>
                                </div>
                          </div>
                          <div className="col-md-6 mb-3">
                          {imagePreviews && <div>
                            <label htmlFor="validationCustom08">
                                Upload Other Images
                            </label>

                            <div>
                              {imagePreviews.map((preview, index) => (
                                <img
                                  key={index}
                                  src={preview}
                                  alt={`Preview ${index}`}
                                  style={{ width: "100px", height: "100px", marginRight: "10px" }}
                                />
                              ))}
                            </div> 
                          </div>}
                          <div className="mb-3 mt-2">
                              <input
                                type="file"
                                name="files"
                                multiple
                                onBlur={handleBlur}
                                onChange={(event) => {
                                  // setSelectedFiles(event.target.files);
                                  handleFileChange(event)
                                  setFieldValue("files", event.target.files);
                                }}
                              />

                              <div style={{ color: "red", fontSize: "12px" }}>
                                {touched.files && errors.files}
                              </div>
                          </div>
                          </div>
                        </div>
                          
                        {/* <label htmlFor="validationCustom08">Upload Image</label>
                        <div className="input-group mt-2">
                          <input
                            type="file"
                            name="files"
                            id="imageId"
                            multiple
                            onBlur={handleBlur}
                            onChange={(e) => {
                              setFieldValue('files', e.target.value);
                              handleFileChange(e)
                            }}
                            value={values.files}
                          />

                          <div style={{ color: "red", fontSize: "12px" }}>
                            {touched.files && errors.files}
                          </div>
                        </div> */}
                        <div className="form-row">
                          <div className="col-md-6 mb-3">
                            <label htmlFor="validationCustom08">
                              Product Type
                            </label>
                            <div className="input-group">
                              <select
                                name="product_group_type"
                                className="form-control"
                                id="productgrouptypeid"
                                required
                                onChange={(e) => {
                                  setFieldValue("product_group_type", e.target.value)
                                  if(e.target.value !== "group"){
                                    setFieldValue("groupProducts", []);
                                  }
                                  handleDropdownChange(e);
                                }}
                                onBlur={handleBlur}
                                value={values.product_group_type}
                              >
                                <option value="">Select Product Type</option>
                                <option value="single">Single</option>
                                <option value="group">Group</option>
                              </select>
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.product_group_type && errors.product_group_type}
                            </div>
                          </div>
                          <div className="col-md-3 mb-3">
                            <label htmlFor="validationCustom08">
                              Stock
                            </label>
                            <div className="input-group">
                              <input
                                name="stock"
                                type="number"
                                className="form-control"
                                id="stockid"
                                placeholder=""
                                required
                                onChange={(e) => {
                                  setFieldValue('stock',e.target.value);
                                  setStockCount(e.target.value)
                                }}
                                onBlur={handleBlur}
                                value={values.stock}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.stock && errors.stock}
                            </div>
                          </div>
                          <div className="col-md-3 mb-3">
                            <label htmlFor="validationCustom08">
                              Low Stock
                            </label>
                            <div className="input-group">
                              <input
                                name="low_stock"
                                type="number"
                                className="form-control"
                                id="lowstockid"
                                placeholder=""
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.low_stock}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.low_stock && errors.low_stock}
                            </div>
                          </div>
                        </div>
                        {showGroupProduct &&
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom25">Group Products</label>
                            <FieldArray
                              name="groupProducts"
                              render={(arrayHelpers) => (
                                <div>
                                  {values.groupProducts.map((gProduct, index) => (
                                    <div key={index}>
                                      <div className="form-row">
                                        <div className="col-md-6 mb-3">
                                            <Select
                                              options={ProductOptions}
                                              onChange={(selectedOption)=>{
                                                setFieldValue(`groupProducts[${index}].product_id`, selectedOption ? selectedOption.value : "")
                                                setProductId(selectedOption.value)
                                              }}
                                              isClearable
                                              placeholder="Select Product"
                                              value={ProductOptions.find(option => option.value === values.groupProducts[index].product_id)}
                                            />
                                          {/* <div className="input-group">
                                            <select
                                              onChange={(e) => {
                                                setFieldValue(`groupProducts[${index}].product_id`, e.target.value)
                                                setProductId(e.target.value);
                                                
                                              }}
                                              onBlur={handleBlur}
                                              className="form-control"
                                              id="validationCustom25"
                                              name={`groupProducts[${index}].product_id`}
                                              // value={color.name}
                                            >
                                              <option value="">Select Product</option>
                                              {products.map((product) => {
                                                return (
                                                  <option key={product.id} value={product.id}>{product.name}</option>
                                                )
                                              })}
                                            </select>
                                          </div> */}
                                        </div>
                                        {/* <div className="col-md-3 mb-3">
                                          <div className="input-group">
                                            <input
                                              onChange={(e) => {
                                                setFieldValue(`groupProducts[${index}].quantity`, e.target.value);
                                                setQuantity(e.target.value);
                                              }}
                                              onBlur={handleBlur}
                                              type="number"
                                              className="form-control"
                                              id="validationCustom26"
                                              placeholder="quantity"
                                              required
                                              name={`groupProducts[${index}].quantity`}
                                            />
                                          </div>
                                        </div> */}
                                        <div className="col-md-3 mb-3">
                                          <button
                                            type="button"
                                            className="ms-btn-icon btn-primary"
                                            name="button"
                                            onClick={() =>
                                              arrayHelpers.remove(index)
                                            }
                                            style={{
                                              marginBottom: "2vh",
                                              backgroundColor: "red",
                                            }}
                                          >
                                            -
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  ))}
                                  <button
                                    type="button"
                                    className="ms-btn-icon btn-primary"
                                    name="button"
                                    onClick={() =>
                                      arrayHelpers.push({
                                        product_id: "",
                                        // quantity: "",
                                      })
                                    }
                                    style={{ marginBottom: "1vh" }}
                                  >
                                    +
                                  </button>
                                </div>
                              )}
                            />
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors.groupProducts}
                            </div>
                          </div>
                        }
                        <div className="form-row mt-5 mb-4">
                          <h6>SEO Section</h6>
                        </div>
                        <div className="form-row">
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">Seo Title</label>
                            <div className="input-group">
                              <input
                                name="seo_title"
                                type="text"
                                className="form-control"
                                id="seoTitleid"
                                placeholder="seo title"
                                required
                                onChange={handleSeoTitleChange}
                                onBlur={handleBlur}
                                value={seoTitle}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.seo_title && errors.seo_title}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Slug
                            </label>
                            <div className="input-group">
                              <input
                                name="slug"
                                type="text"
                                className="form-control"
                                id="slugid"
                                placeholder="slug"
                                required
                                onChange={handleSlugChange}
                                onBlur={handleBlur}
                                value={slug}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.slug && errors.slug}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">
                              Meta Description
                            </label>
                            <div className="input-group">
                              <textarea
                                  name="seo_description"
                                  className="form-control"
                                  id="seoDescripid"
                                  placeholder="description"
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.seo_description}
                                  rows="3"
                                />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.seo_description && errors.seo_description}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">Seo Keywords (Keywords need to be comma-separated)</label>
                            <div className="input-group">
                              <textarea
                                  name="seo_keyword"
                                  className="form-control"
                                  id="seoKeywordpid"
                                  placeholder="keywords"
                                  required
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                  value={values.seo_keyword}
                                  rows="3"
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.seo_keyword && errors.seo_keyword}
                            </div>
                          </div>
                          <div className="col-md-12 mb-3">
                            <label htmlFor="validationCustom08">Image Alt</label>
                            <div className="input-group">
                            <input
                                name="img_alt"
                                type="text"
                                className="form-control"
                                id="altid"
                                placeholder="main image alt"
                                required
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.img_alt}
                              />
                            </div>
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {touched.img_alt && errors.img_alt}
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12 mb-3">
                          <div className="col-md-2" hidden={submitloading}>
                            <div className="spinner spinner-7">
                              <div className="bounce1" />
                              <div className="bounce2" />
                              <div className="bounce3" />
                            </div>
                          </div>
                        </div>

                        <button
                          type="button"
                          className="btn btn-primary shadow-none float-right"
                          onClick={submitForm}
                        >
                          Add Product
                        </button>
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Addproductcontent;
